/**
 * PublicCourseService
 * Anonymous (public) course catalog endpoints
 */
import { BaseService } from '../base/BaseService';
/**
 * Service for the public course catalog (no authentication required)
 */
export class PublicCourseService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? PublicCourseService.DEFAULT_SERVICE_PATH,
            basePath: PublicCourseService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get the public course catalog (courses with open intake dates)
     * @returns Array of public course catalog views
     */
    async catalog() {
        const response = await this.catalogRaw();
        return response.data ?? [];
    }
    /**
     * Get the public course catalog with full response
     * @returns ResponseData with array of public course catalog views
     */
    catalogRaw() {
        const url = this.buildUrl();
        return this.http.get(url);
    }
    /**
     * Get a single public course by ID
     * @param id - The course ID
     * @returns Public course catalog view
     */
    async getCourse(id) {
        const response = await this.getCourseRaw(id);
        if (!response.data) {
            throw new Error(`Public course with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get a single public course by ID with full response
     * @param id - The course ID
     * @returns ResponseData with public course catalog view
     */
    getCourseRaw(id) {
        const url = this.buildUrl(String(id));
        return this.http.get(url);
    }
}
PublicCourseService.DEFAULT_SERVICE_PATH = 'ac-courses';
PublicCourseService.BASE_PATH = 'api/public/courses';
//# sourceMappingURL=PublicCourseService.js.map